import type { ReactNode } from "react";
import { useTranslations } from "use-intl";

import { Button } from "@/components/Button/Button";
import { ErrorPanel } from "@/components/Errors/ErrorPanel";
import { IconAirplaneCrossed, IconHotelCrossed } from "@/components/Icons";

type Props = {
  scope: "flights" | "hotels";
  title: ReactNode;
  onClearFilterClick: () => void;
};

export const NoFilteringResults = ({
  scope,
  title,
  onClearFilterClick,
}: Props) => {
  const t = useTranslations();

  return (
    <ErrorPanel
      icon={scope === "flights" ? IconAirplaneCrossed : IconHotelCrossed}
      primaryText={title}
      secondaryText={t("tryAdjustingFilter")}
    >
      <Button
        onClick={onClearFilterClick}
        variant="outlined"
        borderRoundness="medium"
        color="primary"
        size="small"
      >
        {t("clearFilter")}
      </Button>
    </ErrorPanel>
  );
};
